import * as React from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'
import { StoreProps } from 'src/stores'
import ContainerProps from 'src/components/containers/Resources'
import { ConfiguratorSubHeader } from 'src/components/atoms/configurator'

interface Props extends StoreProps, ContainerProps {
  header?: string
}

const ProductSlider = (props: Props) => {
  const { children, header } = props

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3.5
        }
      },
      {
        breakpoint: 1040,
        settings: {
          slidesToShow: 2.5
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1.5
        }
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1.15
        }
      }
    ]
  }

  return (
    <Wrapper>
      <ConfiguratorSubHeader style={{ marginTop: 10 }}>
        {header}
      </ConfiguratorSubHeader>
      <Slider {...sliderSettings}>{children}</Slider>
    </Wrapper>
  )
}

// Necessary to make the first slide to appear on the left and clear outline
const Wrapper = styled.div`
  position: relative;
  .slick-list > .slick-track {
    margin-left: 0;
  }
  .slick-slide > div {
    margin-right: 7.5px;
    outline: none;
  }
  .slick-slider {
    position: unset;
  }
  .slick-prev:before,
  .slick-next:before {
    color: black;
  }
  .slick-next {
    right: 0;
    top: 11px;
    transform: unset;
  }
  .slick-prev {
    right: 25px;
    top: 11px;
    left: unset;
    transform: unset;
  }
`

export default ProductSlider



// WEBPACK FOOTER //
// ./src/components/containers/configurator/ProductSlider.tsx